import React, { useState } from 'react';
import { ProjectFeature } from '../types';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

interface TechnicalFeaturesProps {
  features: ProjectFeature[];
}

const TechnicalFeatures = ({ features }: TechnicalFeaturesProps) => {
  const [expandedFeature, setExpandedFeature] = useState<string | null>(null);

  const toggleFeature = (featureId: string) => {
    setExpandedFeature(expandedFeature === featureId ? null : featureId);
  };

  return (
    <div className="bg-surface rounded-xl p-6 lg:p-8 elevation-2 mb-8">
      <h2 className="text-2xl font-bold text-text-primary mb-6">Technical Implementation</h2>
      
      <div className="space-y-4">
        {features.map((feature) => (
          <div key={feature.id} className="border border-border rounded-lg overflow-hidden">
            <button
              onClick={() => toggleFeature(feature.id)}
              className="w-full px-6 py-4 text-left hover:bg-muted transition-smooth flex items-center justify-between"
            >
              <div className="flex items-center space-x-3">
                <Icon name={feature.icon} size={20} className="text-accent" />
                <h3 className="text-lg font-semibold text-text-primary">
                  {feature.title}
                </h3>
              </div>
              <Icon 
                name={expandedFeature === feature.id ? "ChevronUp" : "ChevronDown"} 
                size={20} 
                className="text-text-secondary transition-transform"
              />
            </button>
            
            {expandedFeature === feature.id && (
              <div className="px-6 pb-6 border-t border-border">
                <p className="text-text-secondary leading-relaxed mb-4">
                  {feature.description}
                </p>
                
                {feature.image && feature.alt && (
                  <div className="mb-4 rounded-lg overflow-hidden">
                    <Image
                      src={feature.image}
                      alt={feature.alt}
                      className="w-full h-48 object-cover"
                    />
                  </div>
                )}
                
                {feature.codeSnippet && (
                  <div className="bg-gray-900 rounded-lg p-4 overflow-x-auto">
                    <pre className="text-sm text-gray-100">
                      <code>{feature.codeSnippet}</code>
                    </pre>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechnicalFeatures;